import React, { FC } from 'react';
import { CommonApp } from '../../common/components/common-app/CommonApp';
import { ReportTimeSystemEntity } from '../../report-time-system/ReportTimeSystemEntity';
import { LawyerMain } from './LawyerMain';
import { LawyerProvider } from './LawyerContext';

type Props = {
  readKey: string;
};

export const LawyerApp: FC<Props> = ({ readKey }) => (
  <CommonApp>
    <ReportTimeSystemEntity entityType="lawyer" readKey={readKey}>
      <LawyerProvider>
        <LawyerMain />
      </LawyerProvider>
    </ReportTimeSystemEntity>
  </CommonApp>
);
